<template>
	<div style="font-size: 14px; min-width: 1000px;">
		<!--haha-->
		<!--<img src="http://192.168.1.39:8020/CreateCode/20190226135055972.jpg" />-->
		<div class="Madata-box" style="width: 98%;" v-loading="loading">
			<h1 class="Matit">注册信息 </h1>
			<ul class="MadataU f-cb">
				<li class="MadataL f-fl " v-for="(item,index) in registerData" :key="index">
					<!--{{item}}-->
					<div style="border-bottom: 1px solid #e7eef1; padding: 12px;text-align: left;">
						<span class="title" style="text-align: right;display: inline-block;width: 220px; ">{{item.title!=''? item.title+'：' :'' }}</span>
						<span class="contex">{{item.context}}</span>
					</div>

				</li>

			</ul>
			<div class="con-box">
				<span class="title">{{categoryObjectLabel}}码标码：</span>
				<span class="contex" v-for="(item,index) in codeset" style="margin-left: 20px;">{{item.value}}</span>
			</div>
			<!--{{item}}-->
			<div class="con-box" style="vertical-align: top;">
				<span class="title">{{imgdata.name}}图片：</span>
				<div class="contex">
					<div class="describe-box" v-for="(item,index) in imgdata.data" :key="index">
						<img class="icon" :src="item" />
						<!--<a class="tit">{{item.tit}}</a>-->
					</div>
				</div>

			</div>
			<div class="con-box">
				<span class="title">备注：</span>
				<div class="contex">
					{{remarks}}
					<!--<img alt="" />-->
				</div>

			</div>
			<div class="con-box " v-if="tagsshhow">
				<span class="title">详细参数：</span>
				<div class="contex">
					<el-tag v-for="tag in tags" :key="tag.name" :type="tag.type">
						{{tag.name}}
					</el-tag>
				</div>

			</div>
			<div class="con-box f-cb">
				<span class="title f-fl">二维码：</span>
				<div class="contex f-cb ">
					<!--<img alt="" />-->
					<div class="describe-box" v-for="(item,index) in QRimgs" :key="index">
						<img class="icon" :src="item.picUrl" />
						<div>
							<el-button type="text" @click="typeselect({url:item.picUrl,type:item.picName})">{{item.picName}}</el-button>
							<!--<el-button type="primary">下载</el-button>-->
						</div>

						<!--<a class="tit" @click="imgdownload({name:item.picUrl})">{{item.picName}}</a>-->

					</div>
				</div>

			</div>
		</div>

		<!--///////////////////////////////////-->
		<div class="Madata-box" style="width: 98%;">
			<h1 class="Matit">注册信息 </h1>
			<div style="padding:  0 10px;">
				<genreanalysis :id="id"></genreanalysis>
			</div>

		</div>

		<!--下载弹框-->
		<el-dialog title="请选择下载码图类型" :visible.sync="dialogVisible" width="30%">
			<!--<span>这是一段信息</span>-->
			<div>
				<el-radio v-model="radio" label="1">码标码</el-radio>
				<el-radio v-model="radio" label="2">标准码</el-radio>
				<div style="padding-top: 40px;">
					<el-button type="primary" size="medium" @click="imgdownload">下载<i class="el-icon-download el-icon--right"></i></el-button>
				</div>
			</div>

			<span slot="footer" class="dialog-footer">
    <!--<el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>-->
  </span>
		</el-dialog>
	</div>
</template>

<script>
	import genreanalysis from '@/components/Genreanalysis'

	export default {
		components: {
			genreanalysis
		},
		data() {
			return {
				dialogVisible: false,
				loading: false,
				value2: '',
				imgData: {
					name: '',
					url: '',
					type: ''
				},
				registerData: [],
				specialData: [],
				codeset: [],
				QRimgs: [],
				imgdata: {
					name: '',
					data: []
				},
				remarks: '',
				tags: [],
				tagsshhow: '',
				categoryObjectLabel: '',
				radio: '1',

			}
		},
		props: {

			id: [String, Number],
			ma: [String, Number],

		},
		created() {
			//			console.log(this.$store.state.commonalityData.IdcodeUserId)
			console.log(this.ma)
			this.context()
		},
		methods: {
			context() {
				this.loading = true;
				//								console.log(this.id)
				this.$http.get(this.$api + '/categoryApply/getCategoryInfoByRegID', {
					params: {
						categoryregId: this.id,
						mbcode: this.ma
					}

				}).then(res => {
					//					console.log(res.body.entity)

					if(res.body.result === 1) {
						let {
							entity
						} = res.body;

						//                     类型一
						this.registerData.push(

							{
								title: entity.codeUseLabel,
								context: entity.codeUseName
							}, {
								title: '注册类型',
								context: entity.categoryTypeName
							}, {
								title: entity.codeUseLabel + '英文名称',
								context: entity.codeUseNameEn
							}, {
								title: '注册时间',
								context: entity.createDate
							}, {
								title: entity.categoryIDcodeLabel + '代码',
								context: entity.categoryModelNumber
							}, {
								title: entity.categoryIDcodeLabel + 'IDcode',
								context: entity.categoryIDcode
							},

							{
								title: entity.categoryShortCodeLabel + 'IDcode简码',
								context: entity.categoryShortCode
							}, {
								title: '',
								context: ''
							}

						);
						this.imgdata.name = entity.categoryPicLabel;
						this.imgdata.data = entity.categoryPic != null ? entity.categoryPic.split('|') : '';

						this.remarks = entity.categoryIntroduction;
						if(entity.categoryShowType === 2 && entity.categoryDetailPara != null && entity.categoryDetailPara != '') {
							this.tagsshhow = true;
							this.tags = entity.categoryDetailPara.split('|').map((item, index) => {
								return {
									name: item,
									type: ''

								}
							})
						} else {
							this.tagsshhow = false;

						}
						this.categoryObjectLabel = entity.categoryObjectLabel;

						//                     类型二

						//    通信产品IDcode简码  通信产品码标码   产品图片 备注 详细参数 通信产品二维码
						//						this.specialData.push({
						//								title: entity.codeUseLabel,
						//								context: entity.codeUseLabel
						//							}, {
						//								title: entity.codeUseLabel,
						//								context: entity.codeUseLabel
						//							}, {
						//								title: entity.codeUseLabel,
						//								context: entity.codeUseLabel
						//							}, {
						//								title: entity.codeUseLabel,
						//								context: entity.codeUseLabel
						//							}, {
						//								title: entity.codeUseLabel,
						//								context: entity.codeUseLabel
						//							}, {
						//								title: entity.codeUseLabel,
						//								context: entity.codeUseLabel
						//							},
						//
						//						);
						//						console.log(entity)

						this.codeset = entity.categoryObjectInfo.map((item, index) => {
							return {
								value: item.categoryObject,
								//								title:
							}

						})

						//						categoryDetailPara 

						this.QRimgs = entity.categoryCodePic
						//console.log(entity.categoryCodePic)

						//						console.log(this.codeset)

						//                     registerData.push({title:entity.codeUseLabel, context:entity.codeUseLabel});

					}
					this.loading = false;
				}, rej => {

				})

			},
			typeselect({
				name,
				url,
				type
			}) {　
				this.dialogVisible = true;

				//				 imgData:{
				//            	name:'',
				//            	url:''
				//            },
				this.imgData.url = url;

				const actions = new Map([
					['下载QR码', [1, 'IndexPage']],
					['下载汉信码', [4, 'FailPage']],
					['下载龙贝码', [2, 'FailPage']],
					['下载GM码', [5, 'SuccessPage']],
					['下载DM码', [3, 'CancelPage']],
					['default', ['other', 'Index']]
				])
				//				 "ReferenceError: sendLog is not defined"
				const onButtonClick = (status) => {
					let action = actions.get(status) || actions.get('default')
					return action[0]

				}

				this.imgData.type = onButtonClick(type); //                  console.log(onButtonClick(type))
				//				let index = name.lastIndexOf("\/");  

				//      window.location.href ='/categoryApply/ZipDownloads?'+'fileName='+name.substring(index + 1, name.length)+'&filePath=CreateCode'

				//				this.$http.get('http://192.168.1.75:8085/categoryApply/ZipDownloads',{ params:{fileName:name.substring(index + 1, name.length),filePath:'CreateCode' }}).then(res=>{
				////				   console.log(res)
				//				   window.location.href ='http://192.168.1.75:8085/categoryApply/ZipDownloads'res.body
				////				   window.open(res.body)
				//				})

			},
			imgdownload() {

				let {
					imgData,
					ma,
					$store
				} = this;
				//				console.log(ma)
				let Arr = imgData.url.split('/');

				//								if(this.radio == 2) {
				//									//					console.log(imgData.url.split('/')[ ])
				//				//			window.location.href = '/api/categoryApply/ZipDownloads?' + 'fileName=' + Arr[Arr.length - 1] + '&filePath=CreateCode&codeType=&objectCode=&unitId='
				//								
				//							window.location.href = '/api/categoryApply/ZipDownloads?filePath=CreateCode&codeType='+imgData.type+'&objectCode='+this.registerData[5].context+'&unitId='+ $store.state.commonalityData.IdcodeUserId +'&isMB=0'
				//								} else {
				//				            window.location.href = '/api/categoryApply/ZipDownloads?filePath=CreateCode&codeType='+imgData.type +'&objectCode=' + ma +'&unitId='+ $store.state.commonalityData.IdcodeUserId +'&isMB=1'
				//								}

				let objectCode;
				//
				//				console.log(this.registerData)
				objectCode = parseInt(this.radio) === 2 ? this.registerData[5].context : ma;
				//				console.log( '/api/categoryApply/ZipDownloads?filePath=CreateCode&codeType=' + imgData.type + '&objectCode=' + objectCode + '&unitId=' + $store.state.commonalityData.IdcodeUserId + '&isMB=' + (parseInt(this.radio) === 2 ? 0 : 1))
				window.location.href = '/api/categoryApply/ZipDownloads?filePath=CreateCode&codeType=' + imgData.type + '&objectCode=' + objectCode + '&unitId=' + $store.state.commonalityData.IdcodeUserId + '&isMB=' + (parseInt(this.radio) === 2 ? 0 : 1);
				//console.log('/api/categoryApply/ZipDownloads?filePath=CreateCode&codeType=' + imgData.type+ '&objectCode=' + objectCode+ '&unitId=' + $store.state.commonalityData.IdcodeUserId+ '&isMB=' + (this.radio === 2 ? 0 : 1) )
				//+ '&objectCode=' + objectCode + '&unitId= ' + $store.state.commonalityData.IdcodeUserId + '&isMB=' + this.radio === 2 ? 0 : 1)
				//				window.location.href = '/api/categoryApply/ZipDownloads?filePath=CreateCode&codeType=' + imgData.type + '&objectCode=' + objectCode + '&unitId= ' + $store.state.commonalityData.IdcodeUserId + '&isMB=' + this.radio === 2 ? 0 : 1;

			},
		}
	}
</script>

<style lang="scss">
	.special {
		width: 100% !important;
		display: inline-block;
		text-align: left !important;
		padding-left: 40px !important;
		/*border: solid red 1px;*/
	}
	
	.con-box {
		border-bottom: 1px solid #e7eef1;
		padding: 12px;
		text-align: left;
		padding-left: 20px;
		.title {
			width: 200px;
			font-size: 14px;
			text-align: right;
			display: inline-block;
			/*float: left;*/
		}
		.contex {
			display: inline-block;
			margin-left: 10px;
			/*float: left;*/
		}
	}
	
	.describe-box {
		cursor: pointer;
		/*margin: 12px 0;*/
		margin-left: 10px;
		display: inline-block;
		text-align: center;
		.icon {
			width: 100px;
			height: 100px;
			/*border: solid 15px #f7f6f6;*/
		}
		.tit {
			font-size: 14px;
			color: #7c7d80;
			display: inline-block;
			width: 100%;
			margin-top: 8px;
		}
	}
</style>